import { useCallback } from "react";
import { useFetcher } from "react-router";
import { z } from "zod";

import { commitSession } from "~/.server/sessions.server";

import { withZod } from "@rvf/zod";

import { validationError } from "~/components/forms/validationErrorResponse.client";
import { useURL } from "~/contexts";

const RESOURCE_URL = "/resources/store-actions";

const SetStoreSchema = z.object({
  storeId: z.string().min(1),
});

export const SetStoreSchemaValidator = withZod(SetStoreSchema);

export const action = async ({
  request,
  context: { api, auth, session },
}: ActionArgs) => {
  const validation = await SetStoreSchemaValidator.validate(
    await request.clone().formData(),
  );

  /* Handle any validation errros here */
  if (validation.error)
    return validationError(validation.error, validation.submittedData);

  const data = validation.data;
  const customerType = auth.get("customer_type") || "guest";

  if (customerType === "guest") {
    // For guest users, save the store data in session
    session.set("customerStore", data.storeId);

    await commitSession();

    return { success: true };
  } else {
    try {
      await api.shopperCustomers.updateCustomer({
        parameters: { customerId: auth.get("customer_id") || "" },
        body: {
          c_customerStore: data.storeId,
        },
      });
      return { success: true };
    } catch (error) {
      if (error instanceof Error) {
        console.log(error.message);
        return { success: false };
      }
    }
  }
};

export const useStoreActions = () => {
  const fetcher = useFetcher<typeof action>();
  const url = useURL();
  const addStore = useCallback(
    (storeId: string) => {
      fetcher.submit(
        {
          storeId,
        },
        { action: url(RESOURCE_URL), method: "post" },
      );
    },
    [fetcher],
  );

  return { addStore, fetcher };
};
